import type { Epic } from 'redux-observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/concat';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/finally';
import 'rxjs/add/operator/catch';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import fetchRecentBoards from '../../services/recent-boards/index.tsx';
import searchBoards from '../../services/search-boards/index.tsx';
import {
	FETCH_INITIAL_BOARDS,
	initialBoardsFetched,
	initialBoardsFetchFailure,
	startFetchingInitialBoards,
} from '../../state/actions.tsx';
import {
	getBaseUrl,
	wereInitialBoardsFetched,
	isLoadingInitialBoards,
	getLocationType,
} from '../../state/selectors.tsx';
import type { State } from '../../state/types.tsx';
import locationKeyProvider from '../common/location-key-provider/index.tsx';

export const ERROR = 'navigation-apps.scope-switcher-v2.fetch-initial-boards';
export const RECENT_BOARDS_TO_RETRIEVE = 15;

export const browserMetricsKey =
	'navigation-v2.scope-switcher-v2.browser-metrics.fetch-initial-boards';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fetchInitialBoardsEpic: Epic<any, State> = (action$, store) =>
	action$
		.ofType(FETCH_INITIAL_BOARDS)
		.filter(({ payload: forceRetrieve }) => {
			const state = store.getState();
			const wereRecentBoardsFetched = wereInitialBoardsFetched(state);
			const isLoadingRecentBoards = isLoadingInitialBoards(state);
			return forceRetrieve || (!wereRecentBoardsFetched && !isLoadingRecentBoards);
		})
		.switchMap(() => {
			const fetchBoards$ = (locationKey: string) => {
				const state = store.getState();
				const baseUrl = getBaseUrl(state);
				const locationType = getLocationType(state);

				const promise = Promise.all([
					fetchRecentBoards(baseUrl, RECENT_BOARDS_TO_RETRIEVE),
					searchBoards(baseUrl, undefined, locationType, locationKey),
				]);

				return Observable.fromPromise(promise) // eslint-disable-next-line @typescript-eslint/no-explicit-any
					.map(([recentBoards, boardsInLocation]: [any, any]) =>
						initialBoardsFetched({ recentBoards, boardsInLocation }),
					)
					.catch((error) => {
						log.safeErrorWithoutCustomerData(ERROR, error.message, error);
						return Observable.of(initialBoardsFetchFailure());
					});
			};

			return Observable.concat(
				Observable.of(startFetchingInitialBoards()),
				locationKeyProvider(store, fetchBoards$, (errorMessage) => {
					log.safeErrorWithoutCustomerData(ERROR, errorMessage);
					return initialBoardsFetchFailure();
				}),
			);
		});
